import { Options } from "vue-class-component";
import BaseTableInterface from "@/mixins/BaseTableInterface";
import BaseTableMixins from "@/mixins/BaseTable";
import SelectLevel from "@/modules/select-level/select-level.vue";
import DraggableListview from "@/modules/draggable-listview/draggable-listview.vue";
import ActionTableItem from "@/entity/system/master/ActionTableItem";
import API from "@/api/system/master/action1";
import MenuAPI from "@/api/system/master/menu";

@Options({
    name: "app-system-master-action",
    components: {
        "app-select-level": SelectLevel,
        "app-draggable-listview": DraggableListview,
    },
})
export default class Action extends BaseTableMixins<ActionTableItem> implements Partial<BaseTableInterface<ActionTableItem>> {
    private actionTypeList = [
        { value: "1", label: "功能" },
        { value: "2", label: "接口" },
    ];

    public created(): void {
        this.setInterface(this);
        this.tableRequestItem.lockItem = this.getLockItem();
        this.editTableItem = new ActionTableItem();
        this.editModalItem = new ActionTableItem();
    }

    //锁定列数据实体
    public getLockItem(): any {
        return {
            menuId: {
                type: "router",
                name: "menu_id",
                title: "所属菜单",
                parent: -1,
                value: null,
                openFn: this.menuIdLevelModalOpen,
            },
        };
    }

    public activated(): void {
        this.getList(1);
    }

    //MenuAPI
    get getMenuApi(): any {
        return MenuAPI;
    }

    //后端API
    public getApi(): any {
        return API;
    }

    // //列表回调
    // public listCallback(items: Array<ActionTableItem>): void {
    //     return;
    // }

    //添加弹窗配置
    public addModalSetting(): void {
        this.editTableItem = new ActionTableItem();
        this.editModalItem = new ActionTableItem();
        this.editModalItem.menuId = 0;
        this.editModalItem.actionStatus = 1;
        this.editModalItem.actionTypeId = "2";
        this.editModalTitle = "添加功能";
        this.editModalSubmitButtonName = "添加";
    }
    //添加提交检测
    public addSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.actionName)) return "功能名称不能为空！";
        if (this.$tools.isEmpty(this.editModalItem.actionStatus)) return "功能状态不能为空！";
        if (this.$tools.isEmpty(this.editModalItem.actionTypeId)) return "功能类型不能为空！";
        return null;
    }
    // //添加回调
    // public addModalCallback(res: any): void {
    //     return;
    // }

    //修改弹窗配置
    public modModalSetting(): void {
        this.editModalItem.actionTypeId += "";
        this.editModalTitle = "修改功能 (" + this.editModalItem.actionName + ")";
        this.editModalSubmitButtonName = "修改";
    }
    //修改提交检测
    public modSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.actionId)) return "功能ID不能为空！";
        return this.addSubmitChecking();
    }
    // //修改回调
    // public modModalCallback(res: any): void {
    //     return;
    // }

    //删除提示框配置
    public delAlertConfig(): any {
        return {
            type: "okAndNo",
            title: "删除功能",
            message: "功能名称: " + this.editModalItem.actionName + "<br>请确认删除？",
        };
    }
    // //删除提示框配置
    // public delAlertSetting(): void {
    //     return;
    // }
    //删除提示框提交检测
    public delSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.actionId)) return "功能ID不能为空！";
        return null;
    }
    // //删除回调
    // public delModalCallback(res: any): void {
    //     return;
    // }

    //状态提示框配置
    public statusAlertConfig(): any {
        return {
            title: "功能状态",
            message: "功能名称: " + this.editModalItem.actionName + "<br>请确认修改状态？",
            submitButtonName: this.editModalItem.actionStatus === 1 ? "启用" : "禁用",
        };
    }
    //状态切换请求配置
    public toggleStatusSetting(): void {
        this.editModalItem.actionStatus = this.editModalItem.actionStatus === 1 ? 2 : 1;
    }
    //状态切换提交检测
    public toggleStatusSubmitChecking(): string {
        if (this.$tools.isEmpty(this.editModalItem.actionId)) return "功能ID不能为空！";
        return null;
    }
    // //状态切换回调
    // public toggleStatusCallback(): void {
    //     return;
    // }

    //排序弹窗配置
    public sortModalSetting(): void {
        this.editSortBaseTitle = "功能排序";
    }

    //menuId搜索字段
    private menuIdLevelSearchField: any = [
        { field: "menu_name", name: "名称" },
        { field: "menu_remark", name: "说明" },
    ];
    //menuId层级选择器打开
    public menuIdLevelModalOpen() {
        (this.$refs.menuIdLevel as any).openModal();
    }
    //menuId层级选择器提交
    public async menuIdLevelFunction(item: any): Promise<void> {
        const curItem = this.$tools.isEmpty(item.value) ? this.getLockItem().menuId : item;
        this.tableRequestItem.lockItem.menuId.value = curItem.value;
        this.tableRequestItem.lockItem.menuId.title = curItem.title;
        this.tableRequestItem.lockItem.menuId.parent = curItem.parent;
        await this.getList(1);
        return Promise.resolve();
    }

    get menuIdSelectApi() {
        return {
            api: (query: any) => MenuAPI.idSelect(query),
            parent: "menu_parent_id",
            status: "menu_status",
            name: "menu_name",
            id: "menu_id",
            cid: this.editModalItem.menuId,
            cType: 0, //获取功能菜单
        };
    }
}
